import { blue as _blue, cyan as _cyan, green as _green, magenta as _magenta, purple as _purple, red as _red, teal as _teal } from "@carbon/colors";

var getColor = function getColor(obj, shade) {
  return obj[shade];
};

export default {
  blue: function blue(shade) {
    return getColor(_blue, shade);
  },
  cyan: function cyan(shade) {
    return getColor(_cyan, shade);
  },
  green: function green(shade) {
    return getColor(_green, shade);
  },
  magenta: function magenta(shade) {
    return getColor(_magenta, shade);
  },
  purple: function purple(shade) {
    return getColor(_purple, shade);
  },
  red: function red(shade) {
    return getColor(_red, shade);
  },
  teal: function teal(shade) {
    return getColor(_teal, shade);
  }
};